import React from 'react';

export interface StatusPillProps {
	status: 'processing' | 'completed' | 'failed' | 'pending';
	children?: React.ReactNode;
	className?: string;
}

const StatusPill: React.FC<StatusPillProps> = ({
	status,
	children,
	className = '',
}) => {
	const getStatusStyles = () => {
		switch (status) {
			case 'processing':
				return 'bg-warning-200 text-neutral-600';
			case 'completed':
				return 'bg-success-100 text-success-700';
			case 'failed':
				return 'bg-error-100 text-error-700';
			case 'pending':
				return 'bg-warning-100 text-warning-700';
			default:
				return 'bg-neutral-100 text-neutral-700';
		}
	};

	const getStatusText = () => {
		switch (status) {
			case 'processing':
				return 'Processing';
			case 'completed':
				return 'Completed';
			case 'failed':
				return 'Failed';
			case 'pending':
				return 'Pending';
			default:
				return status;
		}
	};

	return (
		<div
			className={`
      h-6 px-2 py-2
      rounded-xl flex justify-center items-center overflow-hidden
      font-primary ${getStatusStyles()} ${className}
    `
				.trim()
				.replace(/\s+/g, ' ')}
		>
			<div className="text-center text-xs font-normal leading-none">
				{children || getStatusText()}
			</div>
		</div>
	);
};

export default StatusPill;
